import { Group } from "@fairfleet/geotab";
import { useMemo } from "react";
import { useGroupByName } from "./useGroupByName";
import { useGroups } from "./useGroups";

export function useGroupsByParent(parentName?: string) {
  const {
    data: parent,
    isLoading: isLoadingParent,
    isError: isErrorParent,
    error: errorParent,
    refetch: refetchParent,
  } = useGroupByName(parentName);

  const {
    data: allGroups = [],
    isLoading: isLoadingAll,
    isError: isErrorAll,
    error: errorAll,
    refetch: refetchAll,
  } = useGroups();

  const data: Group[] = useMemo(() => {
    if (!parent) return [];
    return allGroups.filter(g => parent.children.map(c => c.id).includes(g.id));
  }, [allGroups, parent]);

  return {
    data,
    isLoading: isLoadingParent || isLoadingAll,
    isError: isErrorParent || isErrorAll,
    error: errorParent ?? errorAll,
    refetch: () => {
      refetchParent();
      refetchAll();
    },
  };
}
